interface Props {
  color: string | "#D0DEE6",
}
const LanguageIcon = (props: Props) => {
  return (
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="44" height="44" rx="3.5" fill="white"/>
      <path d="M12.3438 15.4688H26.4062M19.375 13.125V15.4688M23.2812 31.875L27.9688 20.9375L32.6562 31.875M24.7217 28.75H31.2158M23.7354 15.4688C23.7354 15.4688 22.5488 20.0586 19.7168 23.5254C16.8848 26.9922 13.9062 28.75 13.9062 28.75" stroke="#4F46E5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M22.5 26.4062C22.5 26.4062 20.791 25.0879 18.9844 22.7441C17.1777 20.4004 16.25 18.5938 16.25 18.5938" stroke="#4F46E5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <rect x="0.5" y="0.5" width="44" height="44" rx="3.5" stroke="#CCCCCC"/>
    </svg>
  )
}
export default LanguageIcon;
